<div class="flex flex-col gap-4">
  @for (field of fields(); track field.name) {
    <div>
      <label
        class="text-text-primary mb-1 block text-sm font-medium"
        [attr.for]="'recipe-param-' + field.name">
        {{ field.label }}
      </label>

      @if (field.picker; as picker) {
        <app-template-value-input
          [parameter]="picker"
          [inputId]="'recipe-param-' + field.name"
          [label]="field.label"
          [value]="values()[field.name]"
          (valueChange)="setValue(field.name, $event)" />
      } @else {
        @switch (field.widget) {
          @case ('date') {
            <input
              [id]="'recipe-param-' + field.name"
              type="date"
              class="border-weak focus:border-accent-focus focus:ring-accent-focus bg-surface text-text-primary h-9 w-full rounded-md border px-3 text-sm focus:ring-1 focus:outline-none"
              [value]="scalarValue(field.name)"
              (input)="setScalar(field.name, $any($event.target).value)" />
          }
          @case ('date-time') {
            <input
              [id]="'recipe-param-' + field.name"
              type="datetime-local"
              class="border-weak focus:border-accent-focus focus:ring-accent-focus bg-surface text-text-primary h-9 w-full rounded-md border px-3 text-sm focus:ring-1 focus:outline-none"
              [value]="dateTimeInputValue(field.name)"
              (input)="setDateTime(field.name, $any($event.target).value)" />
          }
          @case ('list') {
            <app-multi-autocomplete
              [id]="'recipe-param-' + field.name"
              [ngModel]="listValue(field.name)"
              (ngModelChange)="setList(field.name, $event)"
              [allowCustomValues]="true"
              [placeholder]="'recipe_parameters.list_placeholder' | translate" />
          }
          @default {
            <input
              [id]="'recipe-param-' + field.name"
              type="text"
              class="border-weak focus:border-accent-focus focus:ring-accent-focus bg-surface text-text-primary h-9 w-full rounded-md border px-3 text-sm focus:ring-1 focus:outline-none"
              [value]="scalarValue(field.name)"
              (input)="setScalar(field.name, $any($event.target).value)" />
          }
        }
      }

      @if (field.help) {
        <p class="text-text-tertiary mt-1 text-xs">{{ field.help }}</p>
      }

      @if (contextHint(field.contexts); as hint) {
        <p class="text-text-tertiary mt-1 text-xs italic">{{ hint }}</p>
      }

      @if (errorFor(field.name); as error) {
        <p class="mt-1 text-xs text-red-600 dark:text-red-400">{{ error }}</p>
      }
    </div>
  }
</div>
